import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from 'Components/Atoms/Button';
import useVisitWishInbox from './useVisitWishInbox';

/** The table-only reservation view has no sidebar; keep wishes discoverable there too. */
export default function VisitWishRequestsLink({ restaurantId }: { restaurantId: string }) {
  const { t } = useTranslation('reservations');
  const inbox = useVisitWishInbox(restaurantId);
  if (!inbox.enabled) return null;
  return (
    <Button variant="transparent" linkTo={`/${restaurantId}/reservations/visitWishes`}>
      {t('Visit wishes')} ({inbox.loading || inbox.failed ? '…' : `${inbox.wishes.length}${inbox.hasMore ? '+' : ''}`})
    </Button>
  );
}
